export const COMMERCIAL_WHATSAPP_NUMBER = '5592984162976';
export const COMMERCIAL_EMAIL = 'karlouchoa@gmail.com';

function normalizeText(value) {
    return String(value ?? '').replace(/\n/g, '\r\n').trim();
}

export function buildWhatsAppUrl(message) {
    const text = encodeURIComponent(normalizeText(message));
    return `https://wa.me/${COMMERCIAL_WHATSAPP_NUMBER}?text=${text}`;
}

export function openWhatsApp(message) {
    window.open(buildWhatsAppUrl(message), '_blank', 'noopener,noreferrer');
}

export function buildMailtoUrl({ subject, body, email = COMMERCIAL_EMAIL }) {
    const params = new URLSearchParams({
        subject: normalizeText(subject),
        body: normalizeText(body),
    });

    return `mailto:${email}?${params.toString()}`;
}

export function openMailto(payload) {
    window.location.href = buildMailtoUrl(payload);
}
